import { useAtomValue } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';
import { DealModal } from '../../../../../../pages/DealFlow2/components/DealModal/DealModal';
import {
  activeCompanyListIdStateJ,
  listsByIdStateJ,
  listsStateJ,
} from '../../../../../../services/state/ListsStateJ';
import { updateList } from '../../../../../../services/queries/MaggieListQueries';
import { useToastMessageState } from '../../../../../ToastMessage/ToastMessageProvider';
import { useModalState } from '../../../../../Modal/ModalContext';
import { IListDataModel } from '../../../../../../data-models/list.data-model';
import { CompanyListForm } from './CompanyListForm';

export const EditCompanyListForm = () => {
  const activeListId = useAtomValue(activeCompanyListIdStateJ);
  const listsMap = useAtomValue(listsByIdStateJ);
  const activeList = activeListId != null ? listsMap.get(activeListId) : null;
  const { pushErrorToast, pushSuccessToast } = useToastMessageState();
  const { onCloseModal } = useModalState();

  const handleSubmit = useAtomCallback(
    useCallback(
      async (get, set, vals: Partial<IListDataModel>) => {
        try {
          const updatedList = await updateList(vals, Number(activeListId));

          const currVal = await get(listsStateJ);
          if (currVal) {
            set(
              listsStateJ,
              currVal.map((item) => (item.id === activeListId ? updatedList : item))
            );
          }

          pushSuccessToast({ message: `List ${activeList?.name} updated successfully` });
          onCloseModal();
        } catch {
          pushErrorToast({ message: 'An error occurred while updating the list' });
        }
      },
      [activeListId, activeList?.name, onCloseModal, pushErrorToast, pushSuccessToast]
    )
  );

  return (
    <DealModal title={`Edit ${activeList?.name}`} width={'814px'} contentPadding={'0px 2rem'}>
      <CompanyListForm onSubmit={handleSubmit} isEdit={true} />
    </DealModal>
  );
};
